import React from 'react';
import { motion } from 'framer-motion';
interface SectionRevealProps {
  children: React.ReactNode;
  className?: string;
  delay?: number;
  as?: 'section' | 'div';
}
export function SectionReveal({
  children,
  className = '',
  delay = 0,
  as = 'div'
}: SectionRevealProps) {
  const MotionTag = as === 'section' ? motion.section : motion.div;
  return <MotionTag className={className} initial={{
    opacity: 0,
    y: 32
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    amount: 0.2
  }} transition={{
    duration: 0.6,
    ease: 'easeOut',
    delay
  }} data-id="element-39">
      {children}
    </MotionTag>;
}